import { render } from "./Footer.vue?vue&type=template&id=72a38589&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=72a38589&lang=scss&scoped=true"

import exportComponent from "B:\\桌面\\HTML\\practice\\Vue_exercise\\b2c-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a38589"]])

export default __exports__